import moment, { Moment } from 'moment';
import * as BBApi from '.';

const rootUrl: string = BBApi.host + '/activities';

export async function query(values: Record<string, any>): Promise<{ activities: Record<string, any>[]; totalMatches: number }> {
	const url: URL = new URL(rootUrl);
	url.searchParams.append('offset', String(0));
	url.searchParams.append('amount', values.amount);

	if (values.approved !== 'all') url.searchParams.append('approved', values.approved);
	if (values.status !== 'all') url.searchParams.append('status', values.status);
	if (values.userId !== '') url.searchParams.append('userId', values.userId);
	if (values.activityId !== '') url.searchParams.append('activityId', values.activityId);

	const [dateFrom, dateTo] = values.date;
	if (dateFrom !== null) url.searchParams.append('dateFrom', dateFrom.format('YYYY-MM-DD'));
	if (dateTo !== null) url.searchParams.append('dateTo', dateTo.format('YYYY-MM-DD'));

	if (values.filter.target !== 'all') url.searchParams.append('filter', values.filter.target);
	if (values.filter.search !== '') url.searchParams.append('filterSearch', `%${values.filter.search}%`);

	const response: Response = await BBApi.get(url.href);
	const { activities, totalMatches }: { activities: Record<string, any>[]; totalMatches: number } = await response.json();
	return { activities, totalMatches };
}

export async function getCategories(): Promise<any[]> {
	const response: Response = await BBApi.get(rootUrl + `/categories`);
	const json: any = await response.json();
	return json;
}

export async function updateStatus(id: number, status: number): Promise<void> {
	await BBApi.put(rootUrl + `/${id}/status`, { status });
}

export async function get(id: number): Promise<Record<string, any>> {
	const response: Response = await BBApi.get(rootUrl + `/${id}`);
	const activity: Record<string, any> = await response.json();

	activity.dates = [...activity.activeDates, ...activity.previousDates];
	const isRecurring: boolean = activity.dates.length !== 1;
	activity.isRecurring = isRecurring;

	if (isRecurring === false) {
		const { start_date, end_date } = activity.dates[0];
		activity.dates = [moment(start_date), moment(end_date)];
	} else {
		activity.dates = [null, null];
	}

	return activity;
}

export async function create(activity: any): Promise<any> {
	activity.imageBase64 = activity.imageBase64.split(';base64,').pop();

	activity.dates = activity.dates.map(([start, end]: [Moment, Moment]) => {
		return [start.utc(), end.utc()];
	});

	const response: Response = await BBApi.post(rootUrl, activity);

	if (response.ok === false) {
		throw new Error('Activity not updated');
	}

	const json: any = await response.json();
	return json;
}

export async function update(id: number, activity: any): Promise<void> {
	const response: Response = await BBApi.put(rootUrl + `/${id}`, activity);

	if (response.ok === false) {
		throw new Error('Activity not updated');
	}
}

export async function getImage(id: number): Promise<string> {
	const response: Response = await BBApi.get(rootUrl + `/${id}/image`);
	const json: any = await response.json();
	return 'data:image/jpg;base64,' + json.image;
}

export async function updateImage(id: number, base64: string): Promise<any> {
	const rawBase64: string | undefined = base64.split(';base64,').pop();

	if (rawBase64 === undefined) {
		throw new Error('invalid image');
	}

	const response: Response = await BBApi.put(rootUrl + `/${id}/image`, { base64: rawBase64 });

	if (response.ok === false) {
		throw new Error('test');
	}

	const json: any = await response.json();
	return json.imgFilename;
}

export async function updateDates(id: number, dates: [Moment, Moment][]): Promise<void> {
	const dateSets: [Moment, Moment][] = dates.map(([start, end]: [Moment, Moment]) => {
		return [start.utc(), end.utc()];
	});

	const body: any = { dates: dateSets };
	const response: Response = await BBApi.put(rootUrl + `/${id}/dates`, body);

	if (response.ok === false) {
		throw new Error('Dates not updated');
	}
}

export async function remove(id: number): Promise<void> {
	const response: Response = await BBApi.del(rootUrl + `/${id}`);

	if (response.ok === false) {
		throw new Error('Activity not deleted');
	}
}
